module.exports = "/static/hooks/build/assets/open-iconic-eca2c26759a009a4a9361151efe99e74.svg";